// removed by extract-text-webpack-plugin
module.exports = {"pattern":"src-components-commons-Pattern-style----general-module---pattern---1PJLo position-absolute margin-m display-none breakPointM-display-block"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/Pattern/style/general.module.css
// module id = 1426
// module chunks = 168707334958949